import { DownloadOutlined,PlusOutlined } from '@ant-design/icons';
import { Button, Grid, message,Space } from 'antd';
import { ContentFilters, ContentTopBar } from 'components';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { AddWalletModal } from 'features/transaction_list/component/add-wallet-modal/add-wallet-modal';
import { WalletFilterFormValues } from 'features/transaction_list/component/wallet-filter-form/types';
import { WalletFilterForm } from 'features/transaction_list/component/wallet-filter-form/wallet-filter-form';
import { useState } from 'react';
import { CompanyType } from 'types';

type WalletsTopBarProps = {
  getInitialFilterValues: WalletFilterFormValues;
  handleFilter: (values: WalletFilterFormValues) => void;
};

const { useBreakpoint } = Grid;

export const WalletListTopBar = ({
  getInitialFilterValues,
  handleFilter,
}: WalletsTopBarProps) => {
  useState<CompanyType>();

  const formId = 'Wallet-filters-form';
  const screens = useBreakpoint();
  const [showModal, setShowModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);


  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'visible';
  };

  const handleOpenModal = () => {
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  // ✅ Function to export the wallet report
   const handleExport = async () => {
    try {
      setExportLoading(true);
      await TransectionApiServices().getWalletReportDownload();
      message.success('Wallet report downloaded successfully');
    } catch (error) {
      console.error(error);
      message.error('Failed to download wallet report');
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <>
      {/* Add Wallet Modal */}
      <div className={`cstmrightmdl ${showModal && 'show'}`}>
        <AddWalletModal onClose={handleCloseModal} isOpen={showModal} />
      </div>

      {/* Top Bar with Buttons */}
      <ContentTopBar
        title="Wallet Transactions List"
        renderButtons={
          <Space>
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExport}
              loading={exportLoading}
            >
              Wallet Balance Report

            </Button>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={handleOpenModal}
              type="primary"
            >
              Add Wallet
            </Button>
          </Space>
        }
      />

      {/* Filters */}
      <ContentFilters formId={formId}>
        <WalletFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
